var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{
    bold: _vm.formats.includes('bold'),
    italic: _vm.formats.includes('italic'),
    heading: _vm.formats.includes('heading'),
    deleted: _vm.formats.includes('deleted'),
  }},[(_vm.segment.format === 'url')?[_c('a',{attrs:{"href":_vm.segment.href}},[_vm._v(_vm._s(_vm.textDisplay))])]:(_vm.segment.format === 'internal-url')?[_c('router-link',{attrs:{"to":{ name: _vm.segment.name }}},[_vm._v(_vm._s(_vm.textDisplay))])]:[_vm._v(_vm._s(_vm.textDisplay))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }